import React from 'react';
import { X } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="w-full bg-white py-16 md:py-24 px-4 border-t-2 border-dashed border-gray-200" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-gray-900 mb-6 text-center leading-tight" data-id="element-126">
          El problema no es que ames demasiado...
        </h2>

        <p className="text-xl md:text-2xl text-center text-gray-700 mb-12 font-medium" data-id="element-127">
          El problema es que has aprendido a conformarte con menos de lo que
          mereces.
        </p>

        <div className="bg-brand-cream/50 p-6 md:p-10 rounded-2xl border border-brand-cream mb-12" data-id="element-128">
          <p className="text-lg font-bold text-gray-800 mb-6" data-id="element-129">
            Has normalizado:
          </p>

          <ul className="space-y-5" data-id="element-130">
            {['Esperar mensajes que nunca llegan.', 'Sentirte una opción y no una prioridad.', 'Justificar comportamientos que te lastiman.', 'Dar amor esperando recibir lo mismo.', 'Poner a todos primero y dejarte para después.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-131">
                <div className="mt-1 bg-red-100 p-1 rounded-full flex-shrink-0" data-id="element-132">
                  <X className="w-5 h-5 text-red-600" strokeWidth={3} data-id="element-133" />
                </div>
                <span className="text-lg text-gray-700 font-medium" data-id="element-134">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 text-center max-w-2xl mx-auto mb-12" data-id="element-135">
          <p data-id="element-136">
            Y poco a poco comenzaste a aceptar migajas emocionales creyendo que
            era amor.
          </p>
          <p className="font-bold text-brand-wine" data-id="element-137">Pero no lo es.</p>
          <p data-id="element-138">Porque quien realmente te ama no te mantiene confundida.</p>
          <p data-id="element-139">No te hace dudar de tu valor.</p>
          <p data-id="element-140">No te entrega atención a cuentagotas.</p>
        </div>

        <div className="text-center mb-12" data-id="element-141">
          <h3 className="font-serif text-4xl md:text-6xl font-black text-brand-wine mb-6" data-id="element-142">
            Mereces más.
          </h3>
          <p className="text-xl font-medium text-gray-800" data-id="element-143">
            Y es momento de recordarlo.
          </p>
        </div>

        <CTAButton microtext="DA EL PRIMER PASO HOY" data-id="element-144" />
      </div>
    </section>;
}